import { memo } from 'react';
import { Icon } from 'react-bootstrap-icons';

export const MainDomainIcon: Icon = memo(({
  color = 'currentColor',
  size = '1em',
  ...rest }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15.9375 15.9375"
      width={ size }
      height={ size }
      fill={ color }
      { ...rest }
    >
      { <title>Main domain</title> }

      <path d="M15.9375 7.96875C15.9375 12.3203 12.3281 15.9375 7.96875 15.9375C3.61719 15.9375 0 12.3203 0 7.96875C0 3.60938 3.60938 0 7.96094 0C12.3203 0 15.9375 3.60938 15.9375 7.96875ZM10.125 4.64844L7.99219 10L7.95312 10L5.80469 4.64844C5.66406 4.30469 5.40625 4.125 5.01562 4.125C4.5625 4.125 4.25 4.42969 4.25 4.875L4.25 11.0469C4.25 11.4609 4.47656 11.7109 4.83594 11.7109C5.20312 11.7109 5.42188 11.4688 5.42188 11.0469L5.42188 6.41406L5.5 6.41406L7.34375 11.0391C7.46875 11.3281 7.65625 11.4609 7.96094 11.4609C8.25781 11.4609 8.46094 11.3281 8.57812 11.0391L10.4375 6.41406L10.5078 6.41406L10.5078 11.0469C10.5078 11.4609 10.7266 11.7109 11.0781 11.7109C11.4609 11.7109 11.6797 11.4688 11.6797 11.0469L11.6797 4.875C11.6797 4.42969 11.3672 4.125 10.9219 4.125C10.5312 4.125 10.2734 4.30469 10.125 4.64844Z" fill="inherit"/>
    </svg>
  );
});
